import Footer from "../components/Footer/Footer";
import GirlRunning from "../images/who-we-are/girl-run.png";
import GirlRedBg from "../images/who-we-are/girl-redbg.svg";
import GirlText from "../images/who-we-are/girl-side-text.png";
import GirlWind from "../images/who-we-are/wind.png";
import MainButton from "../components/MainButton";
import FounderImg from "../images/AboutPage/founder.jpg";

function About() {
  const certs = [
    { img: "/certs/certif1.svg", title: "Ironman 70.3", desc: "Finisher of the globally renowned Ironman 70.3 triathlon." },
    { img: "/certs/certif2.svg", title: "RAAM Qualifier", desc: "Official qualification for the prestigious Race Across America endurance event." },
    { img: "/certs/certif3.svg", title: "Super Randonneur", desc: "Awarded for successfully completing the gruelling Super Randonneur cycling events." },
    { img: "/certs/certif4.svg", title: "Asia Book of Records", desc: "Officially recognized as a record holder for exceptional endurance performance." },
    { img: "/certs/certif5.svg", title: "India Book of Records", desc: "National record holder in the India Book of Records for physical endurance." },
    { img: "/certs/certif6.svg", title: "Fitness Excellence", desc: "Recognition for outstanding dedication and legacy in the fitness community, including the Delhi to Mumbai cycle ride (1460km)." }
  ];

  return (
    <>
      <section className="login-section">
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            About Us
          </h1>
        </div>
        <div className="container page-padding py-[5rem]">
          <div className="grid grid-cols-[1fr_1fr] h-[60rem] md1000:grid-cols-1">
            {/* title div -- */}
            <div className="flex flex-col !text-left relative items-right justify-center md1000:items-center md1000:!text-center">
              <p className="text-white relative z-10 text-[15px] uppercase font-bold mb-8 ml-20 md1000:ml-3 ">
                who we are
              </p>

              <h2 className="text-[3.6rem] max-w-[53rem] font-bold mb-4">
                We Will Give You Strength and Health
              </h2>
              <p className="text-[#646464] font-medium text-[15px] max-w-[50rem] mb-6 leading-relaxed">
                Welcome to AK Fitness, a gym and fitness centre located at Atulyam Towers, near Sagda Chowk, Jabalpur. We built AK Fitness for people who want a workout space that feels clean, motivating, and comfortable. Whether you are just starting out or already serious about fitness, we want you to feel confident training here.
              </p>
              <p className="text-[#646464] font-medium text-[15px] max-w-[50rem] leading-relaxed">
                Whether your goal is to lose weight, build muscle, get stronger, improve stamina, or simply live a healthier life, AK Fitness gives you the space, equipment, and support to stay on track.
              </p>
              <MainButton
                color={`!text-white`}
                bg={`bg-[#ff0336]`}
                goTo="/contact"
                text="contact us"
                arrowColor={`!text-white`}
                cN="pricing-cta blog-cta"
              />
            </div>
            {/*  */}
            <div className="relative w-[80%] -top-[90px] left-[40px] md1000:hidden">
              <img
                src={GirlRunning}
                alt="girl_running"
                className="girl-running"
              />
              <img src={GirlRedBg} alt="bg-red" className="girl-bg" />
              <img src={GirlText} alt="bg-text" className="girl-text" />
              <img src={GirlWind} alt="bg-wind" className="girl-wind" />
            </div>
          </div>
          {/*  */}
          <div className="mt-[10rem] mb-[5rem]">
            <div className="flex flex-col items-center text-center px-[20px] mb-12">
              <h2 className="text-[36px] font-bold uppercase md:text-[28px]">Achievements & Legacy</h2>
              <div className="flex flex-wrap justify-center gap-4 mt-6 max-w-[90rem]">
                <span className="bg-[#ff0336] text-white px-5 py-2 rounded-full text-[1.4rem] font-bold shadow-md">#SuperRandonneur</span>
                <span className="bg-[#ff0336] text-white px-5 py-2 rounded-full text-[1.4rem] font-bold shadow-md">#RAAMQualifier</span>
                <span className="bg-[#ff0336] text-white px-5 py-2 rounded-full text-[1.4rem] font-bold shadow-md">#AsiaBookOfRecordsHolder</span>
                <span className="bg-[#ff0336] text-white px-5 py-2 rounded-full text-[1.4rem] font-bold shadow-md">#IndiaBookOfRecordsHolder</span>
                <span className="bg-[#ff0336] text-white px-5 py-2 rounded-full text-[1.4rem] font-bold shadow-md">#Ironman70.3</span>
              </div>
            </div>
            
            <div className="grid grid-cols-2 w-full md1000:grid-cols-1 gap-12 px-[20px] max-w-[120rem] mx-auto items-center">
              <div className="w-full relative h-[50rem] md1000:h-[40rem] rounded-2xl overflow-hidden shadow-2xl group bg-[#1a1a1a]">
                <img src={FounderImg} alt="Atul Mishra" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-8 left-8 text-white">
                  <h3 className="text-[3rem] font-bold uppercase mb-1">Atul Mishra</h3>
                  <p className="text-[1.6rem] text-[#ff0336] font-bold uppercase tracking-wider">AK Fitness</p>
                </div>
              </div>

              <div className="w-full flex flex-col justify-center text-left">
                <p className="text-[1.6rem] font-medium text-[#646464] leading-[1.8] mb-10">
                  Our founder is a symbol of endurance, discipline, and excellence. With remarkable achievements such as being a Super Randonneur, RAAM Qualifier, Ironman 70.3 finisher, and a record holder in both the Asia Book of Records and India Book of Records, he brings a legacy of determination and peak performance. His journey reflects resilience, commitment, and a passion for pushing human limits—values that are deeply embedded into our fitness philosophy and training approach.
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center mt-20 px-[20px]">
              <h2 className="text-[3rem] font-bold uppercase mb-10">Certifications</h2>
              <div className="grid grid-cols-3 gap-8 md1000:grid-cols-2 min620:grid-cols-1 max-w-[120rem] mb-10">
                {certs.map((cert, idx) => (
                  <div key={idx} className="bg-white p-4 rounded-xl shadow-2xl flex items-center justify-center border border-gray-200 relative group overflow-hidden">
                    <img src={cert.img} alt={cert.title} className="w-full h-[30rem] object-contain group-hover:scale-110 transition-transform duration-500" />
                    
                    <div className="absolute inset-0 bg-black/85 flex flex-col items-center justify-center p-8 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                       <h3 className="text-[2.2rem] font-bold text-[#ff0336] mb-4 uppercase">{cert.title}</h3>
                       <p className="text-[1.5rem] text-white font-medium leading-relaxed">{cert.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col items-center mt-10 mb-20 px-[20px] max-w-[120rem] mx-auto">
              <h2 className="text-[3rem] font-bold uppercase mb-10 text-center">Official Record Holder</h2>
              <div className="grid grid-cols-2 gap-10 md1000:grid-cols-1 w-full">
                <a href="https://www.asiabookofrecords.com/fastest-to-cover-quarter-marathon-distance-while-performing-dandvat-pranam/" target="_blank" rel="noreferrer" className="flex items-center min450:flex-col min450:text-center gap-8 bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 group">
                  <div className="w-[12rem] h-[12rem] shrink-0 bg-gray-50 rounded-full flex items-center justify-center p-4 border-2 border-transparent group-hover:border-[#ff0336] transition-colors overflow-hidden">
                    <img src="/certs/asia-book.png" alt="Asia Book of Records" className="w-full h-full object-contain group-hover:scale-110 transition-transform" />
                  </div>
                  <div>
                    <h3 className="text-[2.2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors">Asia Book of Records</h3>
                    <p className="text-[1.5rem] text-gray-500 mt-2 font-medium leading-relaxed">Fastest to cover quarter marathon distance while performing dandvat pranam.</p>
                    <span className="text-[1.4rem] font-bold text-[#ff0336] mt-4 inline-block uppercase tracking-wider">View Official Record &rarr;</span>
                  </div>
                </a>
                
                <a href="https://indiabookofrecords.in/fastest-to-cover-quarter-marathon-distance-while-performing-dandvat-pranam/" target="_blank" rel="noreferrer" className="flex items-center min450:flex-col min450:text-center gap-8 bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 group">
                  <div className="w-[12rem] h-[12rem] shrink-0 bg-gray-50 rounded-full flex items-center justify-center p-4 border-2 border-transparent group-hover:border-[#ff0336] transition-colors overflow-hidden">
                    <img src="/certs/india-book.jpg" alt="India Book of Records" className="w-full h-full object-contain group-hover:scale-110 transition-transform" />
                  </div>
                  <div>
                    <h3 className="text-[2.2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors">India Book of Records</h3>
                    <p className="text-[1.5rem] text-gray-500 mt-2 font-medium leading-relaxed">Fastest to cover quarter marathon distance while performing dandvat pranam.</p>
                    <span className="text-[1.4rem] font-bold text-[#ff0336] mt-4 inline-block uppercase tracking-wider">View Official Record &rarr;</span>
                  </div>
                </a>
              </div>
            </div>

            {/* Why Choose AK Fitness */}
            <div className="flex flex-col items-center mt-24 px-[20px] max-w-[120rem] mx-auto">
              <h2 className="text-[3rem] font-bold uppercase mb-10 text-center">Why Choose AK Fitness?</h2>
              <div className="grid grid-cols-4 gap-8 md1000:grid-cols-2 min620:grid-cols-1 w-full mb-24">
                
                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 flex flex-col gap-4 group">
                  <div className="w-[5.5rem] h-[5.5rem] bg-[#ff0336]/10 rounded-full flex items-center justify-center text-[#ff0336] group-hover:bg-[#ff0336] group-hover:text-white transition-colors duration-300">
                    <i className="fa-solid fa-dumbbell text-[2.2rem]"></i>
                  </div>
                  <h3 className="text-[2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors duration-300">Modern Training Environment</h3>
                  <p className="text-[1.5rem] text-[#646464] font-medium leading-relaxed">
                    Work out in a spacious and well-designed gym that helps you stay focused and motivated.
                  </p>
                </div>

                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 flex flex-col gap-4 group">
                  <div className="w-[5.5rem] h-[5.5rem] bg-[#ff0336]/10 rounded-full flex items-center justify-center text-[#ff0336] group-hover:bg-[#ff0336] group-hover:text-white transition-colors duration-300">
                    <i className="fa-solid fa-heart-pulse text-[2.2rem]"></i>
                  </div>
                  <h3 className="text-[2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors duration-300">Quality Equipment</h3>
                  <p className="text-[1.5rem] text-[#646464] font-medium leading-relaxed">
                    We have the equipment you need for strength training, cardio, functional fitness, and everyday workouts.
                  </p>
                </div>

                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 flex flex-col gap-4 group">
                  <div className="w-[5.5rem] h-[5.5rem] bg-[#ff0336]/10 rounded-full flex items-center justify-center text-[#ff0336] group-hover:bg-[#ff0336] group-hover:text-white transition-colors duration-300">
                    <i className="fa-solid fa-users text-[2.2rem]"></i>
                  </div>
                  <h3 className="text-[2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors duration-300">Beginner-Friendly Support</h3>
                  <p className="text-[1.5rem] text-[#646464] font-medium leading-relaxed">
                    If you are new to the gym, our team is here to help you start the right way and feel comfortable from day one.
                  </p>
                </div>

                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200 flex flex-col gap-4 group">
                  <div className="w-[5.5rem] h-[5.5rem] bg-[#ff0336]/10 rounded-full flex items-center justify-center text-[#ff0336] group-hover:bg-[#ff0336] group-hover:text-white transition-colors duration-300">
                    <i className="fa-solid fa-bullseye text-[2.2rem]"></i>
                  </div>
                  <h3 className="text-[2rem] font-bold text-black group-hover:text-[#ff0336] transition-colors duration-300">Focus on Real Fitness Goals</h3>
                  <p className="text-[1.5rem] text-[#646464] font-medium leading-relaxed">
                    From fat loss and muscle gain to better overall health, we help members work toward goals that are practical and achievable.
                  </p>
                </div>

              </div>
            </div>

            {/* Mission & Vision */}
            <div className="grid grid-cols-2 gap-10 md1000:grid-cols-1 w-full max-w-[120rem] mx-auto mb-24 px-[20px]">
              <div className="bg-gradient-to-br from-black to-neutral-900 text-white p-12 rounded-3xl shadow-xl border border-neutral-800 flex flex-col gap-6 relative overflow-hidden group hover:shadow-2xl transition-all duration-300">
                <div className="absolute top-0 right-0 w-[15rem] h-[15rem] bg-[#ff0336]/5 rounded-full blur-3xl -mr-10 -mt-10 group-hover:bg-[#ff0336]/10 transition-all duration-500"></div>
                <div className="w-[6rem] h-[6rem] bg-[#ff0336] rounded-2xl flex items-center justify-center text-white shadow-lg shadow-[#ff0336]/30">
                  <i className="fa-solid fa-rocket text-[2.5rem]"></i>
                </div>
                <h3 className="text-[2.6rem] font-bold uppercase tracking-wide">Our Mission</h3>
                <span className="bg-[#ff0336] w-[60px] h-[4px]"></span>
                <p className="text-[1.6rem] text-neutral-300 font-medium leading-relaxed mt-2">
                  To help people in Jabalpur become stronger, healthier, and more confident through quality fitness training and a positive gym environment.
                </p>
              </div>

              <div className="bg-gradient-to-br from-black to-neutral-900 text-white p-12 rounded-3xl shadow-xl border border-neutral-800 flex flex-col gap-6 relative overflow-hidden group hover:shadow-2xl transition-all duration-300">
                <div className="absolute top-0 right-0 w-[15rem] h-[15rem] bg-[#ff0336]/5 rounded-full blur-3xl -mr-10 -mt-10 group-hover:bg-[#ff0336]/10 transition-all duration-500"></div>
                <div className="w-[6rem] h-[6rem] bg-[#ff0336] rounded-2xl flex items-center justify-center text-white shadow-lg shadow-[#ff0336]/30">
                  <i className="fa-solid fa-eye text-[2.5rem]"></i>
                </div>
                <h3 className="text-[2.6rem] font-bold uppercase tracking-wide">Our Vision</h3>
                <span className="bg-[#ff0336] w-[60px] h-[4px]"></span>
                <p className="text-[1.6rem] text-neutral-300 font-medium leading-relaxed mt-2">
                  To become one of Jabalpur’s most trusted fitness destinations for people looking for professional training, modern facilities, and long-term results.
                </p>
              </div>
            </div>

          </div>

        </div>
        <Footer />
      </section>
    </>
  );
}

export default About;
